export const EXHIBITION_PATH = "/BigC_Exhibition";
// หน้าแผนที่ใช้ slug พิเศษใต้ path เดิม จึงไม่ต้องเพิ่ม route ใน App.js
export const MAP_SLUG = "map";
export const MAP_PATH = `${EXHIBITION_PATH}/${MAP_SLUG}`;

export const reducedMotion =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const scrollToId = (id, block = "start") =>
  document.getElementById(id)?.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block });
